import React, { useCallback, useState } from "react";
import SnackbarUtils from "../../../../../libs/SnackbarUtils";
import {
  serviceExitGroup,
  serviceGroupDelete,
} from "../../../../../services/Chat.service";
import { useSelector } from "react-redux";
import RouteName from "../../../../../routes/Route.name";
import { useLocation } from "react-router-dom";
import historyUtils from "../../../../../libs/history.utils";

function useGroupMenuHook({ groupId, setChatUser, handleClosepopOver }) {
  const [sidePanel, setSidePanel] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [exitDialog, setExitDialog] = useState(false);
  const [sidePanelType, setSidePanelType] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [coAdminDialog, setCoAdminDialog] = useState(false);
  const {
    user: { id: emp_id },
  } = useSelector((state) => state.auth);

  const location = useLocation();
  const toggleDeleteDialog = useCallback(
    (obj) => {
      setIsDelete((e) => !e);
    },
    [isDelete]
  );

  const toggleCoAdminDialog = useCallback(() => {
    setCoAdminDialog((s) => !s);
  }, [coAdminDialog]);

  const toggleExitDialog = useCallback(() => {
    setExitDialog((e) => !e);
  }, [exitDialog]);
  const handleDelete = useCallback(() => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      serviceGroupDelete({ id: groupId }).then((res) => {
        if (!res.error) {
          SnackbarUtils.success("Deleted Successfully");
          setChatUser(null);
          historyUtils.replace(
            location?.pathname === "/messaging"
              ? RouteName.MESSAGING
              : RouteName.AUDIT_GROUP
          );
        } else {
          SnackbarUtils.error(res?.message);
        }
        setIsSubmitting(false);
      });
    }
  }, [setIsSubmitting, isSubmitting, groupId]);

  const handleExit = useCallback(
    (newAdminId = {}) => {
      if (!isSubmitting) {
        setIsSubmitting(true);
        serviceExitGroup({
          id: groupId,
          employee_id: emp_id,
          ...newAdminId,
        }).then((res) => {
          if (!res.error) {
            SnackbarUtils.success("Leave Successfully");
            setChatUser(null);
            historyUtils.replace(
              location?.pathname === "/messaging"
                ? RouteName.MESSAGING
                : RouteName.AUDIT_GROUP
            );
          } else {
            SnackbarUtils.error(res?.message);
          }
          setIsSubmitting(false);
        });
      }
    },
    [setIsSubmitting, isSubmitting, emp_id, groupId]
  );

  const handleSideToggle = useCallback((type) => {
    setSidePanelType(type);
    setSidePanel(true);
  }, []);

  const handleCloseSidePanel = useCallback(() => {
    handleClosepopOver && handleClosepopOver();
    setSidePanel(false);
    setSidePanelType(null);
  }, []);

  return {
    sidePanel,
    handleSideToggle,
    handleCloseSidePanel,
    sidePanelType,
    isDelete,
    toggleDeleteDialog,
    handleDelete,
    handleExit,
    exitDialog,
    toggleExitDialog,
    coAdminDialog,
    toggleCoAdminDialog,
  };
}

export default useGroupMenuHook;
